/**
 * T-176-003 cookie-consent gate + opt-out control (batch 4 S8).
 *
 * Renders a dismissible bar until the user has decided. "Accept" grants
 * analytics consent (Mixpanel/GA sends resume); "Decline" opts out fully
 * (mixpanel opt_out_tracking + denied flag persisted). Undecided visitors
 * get no analytics sends at all — the facade gates every event on consent.
 */
import React, { useState } from 'react';
import { getAnalyticsConsent, setAnalyticsConsent } from '../../services/analytics';

const ConsentBanner: React.FC = () => {
  const [decided, setDecided] = useState<boolean>(getAnalyticsConsent() !== null);

  if (decided) return null;

  const accept = () => {
    setAnalyticsConsent(true);
    setDecided(true);
  };
  const decline = () => {
    setAnalyticsConsent(false);
    setDecided(true);
  };

  return (
    <div
      data-testid="consent-banner"
      className="fixed bottom-0 inset-x-0 z-50 bg-slate-900 text-white px-4 py-3 shadow-lg flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-6"
    >
      <p className="text-sm text-slate-200 flex-1">
        We use cookies and analytics to understand how the platform is used and to improve it.
        You can change your choice any time.
      </p>
      <div className="flex gap-2 shrink-0">
        <button
          type="button"
          data-testid="consent-accept"
          onClick={accept}
          className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-4 py-2 rounded"
        >
          Accept
        </button>
        <button
          type="button"
          data-testid="consent-decline"
          onClick={decline}
          className="bg-transparent border border-slate-500 hover:bg-slate-700 text-slate-200 text-sm font-semibold px-4 py-2 rounded"
        >
          Decline
        </button>
      </div>
    </div>
  );
};

export default ConsentBanner;